import axios from "axios";
import { message, notification } from "ant-design-vue";
import moment from "moment";
import router from "../router";
// import store from '../store'
import db from "utils/localstorage";
moment.locale("zh-cn");

// 统一配置
let FEBS_REQUEST = axios.create({
  baseURL: '/api/',
  // baseURL: "http://172.18.30.180:9528",
  // baseURL: "http://172.18.1.113:8202/api",//测试环境
  // baseURL: "http://172.18.1.68:9528",
  // baseURL: "http://172.18.30.191:9528", // 伟雄IP
  // baseURL: "http://172.18.30.148:9528", // 泳良IP

  // baseURL: "https://gasmon.ncweal.com/api/",//生产环境
  responseType: "json",
  validateStatus(status) {
    // 200 外的状态码都认定为失败
    return status === 200;
  }
});

// 是否正在刷新的标记
let isRefreshing = false;

// 重试队列，每一项将是一个待执行的函数形式
let requests = [];
// 是否正在刷新的标记
let isRefreshing1 = false;

// 重试队列，每一项将是一个待执行的函数形式
let requests1 = [];

function refreshToken() {
  let refreshToken = db.get("REFRESH_TOKEN");
  // console.log("REFRESH_TOKEN", refreshToken);
  return FEBS_REQUEST.get("/reLogin", {
    params: {
      refreshToken: refreshToken
    }
  }).then(res => res.data);
}
// 拦截请求
FEBS_REQUEST.interceptors.request.use(
  config => {
    let expireTime = db.get("EXPIRE_TIME");
    // let refreshTokenExpireTime = db.get("REFRESH_EXPIRE_TIME"); // 刷新token过期时间
    let now = moment().format("YYYYMMDDHHmmss");
    // 让token早10秒种过期，提升“请重新登录”弹窗体验
    // console.log("当前时间", now);
    // console.log("token过期时间", expireTime);
    // console.log("距离token过期->", now - expireTime);
    // console.log("距离刷新token过期->", now - refreshTokenExpireTime);
    // 有 token就带上
    if (db.get("USER_TOKEN")) {
      config.headers.Authentication = db.get("USER_TOKEN");
    }
    // console.log('config.url.indexOf("/reLogin")',config.url,config.url.indexOf("/reLogin"))
    if (
      config.url.indexOf("/reLogin") >= 0 ||
      config.url.indexOf("/login") >= 0 ||
      config.url.indexOf("/checkLoginUrl") >= 0
    ) {
      return config;
    }
    // 提前600s刷新token
    if (now - expireTime >= -160 && db.get("REFRESH_TOKEN")) {
      // 在这里刷新token
      // console.log("isRefreshing", isRefreshing);
      if (!isRefreshing) {
        isRefreshing = true;
        refreshToken()
          .then(res => {
            let token = res.accessToken;
            if (token) {
              // console.log("accessToken->", res);
              db.save("USER_TOKEN", res.accessToken);
              db.save("EXPIRE_TIME", res.accessTokenExpireTimeStr);
              db.save("REFRESH_TOKEN", res.refreshToken);
              db.save("REFRESH_EXPIRE_TIME", res.refreshTokenExpireTimeStr);
            }
            isRefreshing = false;
            return token;
          })
          .catch(() => {
            isRefreshing = false;
          })
          .then(token => {
            // console.log("刷新token成功,执行队列");
            // 清空缓存的请求
            if (token) {
              requests.forEach(cb => cb(token));
            }
            requests = [];
          });
      }
      // 正在刷新token，将要发送的请求存在一个数组中，等刷新之后再发送请求
      const retryQriginalRequest = new Promise(resolve => {
        requests.push(accessToken => {
          config.headers.Authentication = accessToken;
          resolve(config);
        });
      });
      return retryQriginalRequest;
      // }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 拦截响应
FEBS_REQUEST.interceptors.response.use(
  config => {
    // console.log("响应", config);
    return config;
  },
  error => {
    if (error.response) {
      // console.log("错误信息", error.response);
      let responseData = error.response.data;
      if (error.request.responseType === "blob") {
        let reader = new FileReader();
        reader.readAsText(responseData, "utf-8");
        reader.onload = function () {
          responseData = JSON.parse(reader.result);
          // console.log("++++", responseData);
          let errorMessage = responseData.message;
          notification.error({
            message: "系统提示",
            description: errorMessage,
            duration: 4
          });
        };
      } else {
        let errorMessage =
          error.response.data === null
            ? "系统内部异常，请联系网站管理员"
            : error.response.data.message;
        // let refreshTokenExpireTime = db.get('REFRESH_EXPIRE_TIME') // 刷新token过期时间
        // let now = moment().format('YYYYMMDDHHmmss')
        switch (error.response.status) {
          case 404:
            notification.error({
              message: "系统提示",
              description: "很抱歉，资源未找到",
              duration: 4
            });
            break;
          case 403:
            notification.warn({
              message: "系统提示",
              description: "很抱歉，您无法访问该资源，可能是因为没有相应权限",
              duration: 4
            });
            break;
          case 401:
            // console.log("url", error.request.responseURL);
            let requestUrl = error.request.responseURL;
            let str = "/reLogin";
            let regex = new RegExp(str);
            // console.log("刷新tokenurl+++", regex.test(requestUrl));
            if (regex.test(requestUrl)) {
              let systemName = db.get("systemName");
              let systemLogo = db.get("systemLogo");
              db.clear();
              db.save("systemName", systemName);
              db.save("systemLogo", systemLogo);
              router.push({
                path: "/login/"
              });
            } else {
              const config = error.response.config;
              if (!isRefreshing1) {
                isRefreshing1 = true;
                return refreshToken()
                  .then(res => {
                    if (res.accessToken) {
                      const { accessToken, refreshToken } = res;
                      db.save("USER_TOKEN", accessToken);
                      db.save("REFRESH_TOKEN", refreshToken);
                      config.headers.Authentication = accessToken;
                      config.baseURL = "";
                      // 已经刷新了token，将所有队列中的请求进行重试
                      requests1.forEach(cb => cb(accessToken));
                      return FEBS_REQUEST(config);
                    }
                    requests1 = [];
                  })
                  .catch(res => {
                    console.error("refreshtoken error =>", res);
                    let systemName = db.get("systemName");
                    let systemLogo = db.get("systemLogo");
                    db.clear();
                    db.save("systemName", systemName);
                    db.save("systemLogo", systemLogo);
                    router.push({
                      path: "/login/"
                    });
                  })
                  .finally(() => {
                    isRefreshing1 = false;
                  });
              } else {
                // 正在刷新token，将返回一个未执行resolve的promise
                return new Promise(resolve => {
                  // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
                  requests1.push(accessToken => {
                    config.baseURL = "";
                    config.headers.Authentication = accessToken;
                    resolve(FEBS_REQUEST(config));
                  });
                });
              }
            }
            break;
          default:
            notification.error({
              message: "系统提示",
              description: errorMessage,
              duration: 4
            });
            break;
        }
      }
    }
    return Promise.reject(error);
  }
);

const request = {
  post(url, params) {
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [
        params => {
          let result = "";
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(params[key]) +
                "&";
            }
          });
          return result;
        }
      ],
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },
  postJson(url, data) {
    return FEBS_REQUEST.post(url, data, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  },
  put(url, params) {
    return FEBS_REQUEST.put(url, params, {
      transformRequest: [
        params => {
          let result = "";
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(params[key]) +
                "&";
            }
          });
          return result;
        }
      ],
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },
  get(url, params) {
    let t = Date.now();
    let _params;
    if (Object.is(params, undefined)) {
      _params = "?";
    } else {
      _params = "?";
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`;
        }
      }
    }
    return FEBS_REQUEST.get(encodeURI(`${url}${_params}_t=${t}`)); // 处理ie中文乱码和缓存
  },
  delete(url, params) {
    let _params;
    if (Object.is(params, undefined)) {
      _params = "";
    } else {
      _params = "?";
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`;
        }
      }
    }
    return FEBS_REQUEST.delete(`${url}${_params}`);
  },
  export(url, params = {}, myfileName = "导出数据.xlsx") {
    const hide = this.$message.loading("导出数据中", 0);
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [
        params => {
          let result = "";
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(params[key]) +
                "&";
            }
          });
          return result;
        }
      ],
      responseType: "blob"
    })
      .then(r => {
        const content = r.data;
        const blob = new Blob([content]);
        let fileName = "";
        if (r.headers["content-disposition"]) {
          fileName = decodeURI(
            r.headers["content-disposition"].split(";")[1].split("=")[1]
          );
        } else {
          fileName = myfileName;
        }
        // console.log(window.navigator);
        if ("download" in document.createElement("a")) {
          if ("msSaveOrOpenBlob" in window.navigator) {
            navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
          // this.$message.success('导出成功', 1)
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
        setTimeout(hide, 10);
      })
      .catch(r => {
        console.error(r);
        setTimeout(hide, 10);
        message.error("导出失败");
      });
  },
  download(url, params, filename) {
    message.loading("文件传输中");
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [
        params => {
          let result = "";
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(params[key]) +
                "&";
            }
          });
          return result;
        }
      ],
      responseType: "blob"
    })
      .then(r => {
        const content = r.data;
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          const elink = document.createElement("a");
          elink.download = filename;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, filename);
        }
      })
      .catch(r => {
        console.error(r);
        message.error("下载失败");
      });
  },
  upload(url, params) {
    return FEBS_REQUEST.post(url, params);
  },
  submit(url, params) {
    return FEBS_REQUEST.post(url, params, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  },
  putEdit(url, params) {
    return FEBS_REQUEST.put(url, params, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
};

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js